import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { ChartData } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'recrewt-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss'],
})
export class PieChartComponent implements OnInit, OnChanges {
  constructor(private translate: TranslateService) {}

  public pieChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
        },
      },
    },
  };

  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  @Input() public labels: any[] = [];

  @Input() public data: any[] = [];

  public pieChartType = 'pie';

  public pieChartLegend = true;

  public pieChartPlugins = [];

  public pieChartData: ChartData<'pie', number[], string | string[]> = {
    datasets: [
      {
        data: [300, 500, 100],
      },
    ],
  };

  colors: any[] = [
    {
      backgroundColor: ['#fbc880', '#ff8f00', '#f16100', '#f29dbe', '#e53a7d', '#d3184d'],
    },
  ];

  public setColor(): void {
    for (let i = 0; i < Math.min(this.colors[0].backgroundColor.length, this.data.length); i++) {}

    this.chart?.update();
  }

  ngOnInit() {
    this.pieChartData = {
      labels: this.labels.map((label) => this.translate.instant(label)),
      datasets: [{ data: this.data }],
    };
    this.pieChartData.datasets[0].backgroundColor = this.colors[0].backgroundColor;
  }

  ngOnChanges() {
    this.pieChartData.datasets[0].backgroundColor = this.colors[0].backgroundColor;
  }
}
